export default "__VITE_ASSET__DvjTZs9M__"